import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IOfferCard, IOfferCardFormData, IOffersListFormData } from '../models';
import { CreateOfferDataService, OffersSearchDataService, ProductsRetailerSearchDataService, DataTableService } from '../_services';
import { AppState } from '../state/app.state';
import { ResolveBase } from './resolve-base';
import { OffersListState, OffersListViewType } from '../cards/offers/offers-list.state';
import { LOCAL_STORAGE_KEY } from '../config';
import { LocalStorage } from '../_helpers';
import { OfferKind } from '../enum';
import { Router } from '@angular/router';

@Injectable()
export class OfferCardResolve extends ResolveBase {
  req(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.http.get<IOfferCard>(`api/offers/${route.paramMap.get('offerId')}`);
  }
}

@Injectable()
export class CloneOfferCardResolve extends ResolveBase {

  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  req(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.http.get<IOfferCard>(`api/offers/${route.paramMap.get('offerId')}/clone`);
  }
}

@Injectable()
export class OfferCardFromCalendarEntryResolve extends ResolveBase {

  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  req(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.http.get<IOfferCard>(`api/offers/createFromCalendarEntry/${route.paramMap.get('calendarEntryId')}`);
  }
}

@Injectable()
export class OfferCardFormDataResolve implements Resolve<any> {
  constructor(private _http: HttpClient, private _createOfferDataService: CreateOfferDataService) { }
  resolve(route: ActivatedRouteSnapshot) {

    var productIds = this._createOfferDataService.productIds;
    this._createOfferDataService.productIds = [];
    
    return this._http.post<IOfferCardFormData>(`api/offers/formData`, {
      productIds: productIds
    });
  }
}

@Injectable()
export class OffersListFormDataResolve implements Resolve<any> {
  constructor(private _http: HttpClient) { }
  resolve(route: ActivatedRouteSnapshot): Observable<IOffersListFormData> {

    var searchKey = route.paramMap.get("searchKey");
    var url = 'api/offers/listFormData';
    if (searchKey) {
      url += `/${searchKey}`;
    }

    return this._http.get(url) as Observable<IOffersListFormData>;
  }
}

@Injectable()
export class RequestedOffersListFormDataResolve implements Resolve<any> {
  constructor(private _http: HttpClient) { }
  resolve(route: ActivatedRouteSnapshot): Observable<IOffersListFormData> {

    var searchKey = route.paramMap.get("searchKey");
    var url = 'api/offers/requests/listFormData';
    if (searchKey) {
      url += `/${searchKey}`;
    }

    return this._http.get(url) as Observable<IOffersListFormData>;
  }
}

@Injectable()
export class ReceivingOffersListDataResolve implements Resolve<any> {

  constructor(
    private _http: HttpClient, 
    private _listState: OffersListState, 
    private _state: OffersSearchDataService,
    private _dataTableService: DataTableService<any, any>
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    let searchData: any = this._state.serializeBuyerSearchData();

    const { offerKind } = route.data || {};
    this._listState.initializeListViewType(offerKind || OfferKind.ReceivingOffer);

    const dataUrl = 'offers/forRetailer';
    
    return this._dataTableService.handleResolverRequest(
      dataUrl,
      (params) => {
        if (this._listState.listFilter) {
          params.$filter = this._listState.listFilter;
        }
        return this._http.post(`api/offers/forRetailer`, searchData, { params });
      },
      route.queryParams,
      LOCAL_STORAGE_KEY.PAGE_SIZE_OFFERS_LIST
    );
  }
}


@Injectable()
export class SendingOffersListDataResolve implements Resolve<any> {

  constructor(
    private _http: HttpClient, 
    private _listState: OffersListState, 
    private _state: OffersSearchDataService,
    private _dataTableService: DataTableService<any, any>
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const req = this._state.serializeSellerSearchData();

    const { offerKind } = route.data || {};
    this._listState.initializeListViewType(offerKind || OfferKind.SupplierOffer);

    const dataUrl = 'offers/forSupplier';
    
    return this._dataTableService.handleResolverRequest(
      dataUrl,
      (params) => {
        if (this._listState.listFilter) {
          params.$filter = this._listState.listFilter;
        }
        return this._http.post(`api/offers/forSupplier`, req, { params });
      },
      route.queryParams,
      LOCAL_STORAGE_KEY.PAGE_SIZE_OFFERS_LIST
    );
  }
}

@Injectable()
export class RequestedOffersListDataResolve implements Resolve<any> {

  constructor(
    private _http: HttpClient, 
    private _listState: OffersListState, 
    private _state: OffersSearchDataService,
    private _dataTableService: DataTableService<any, any>
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const req = this._state.serializeBuyerSearchData();

    const { offerKind } = route.data || {};
    this._listState.initializeListViewType(offerKind || OfferKind.ReceivingOffer);

    const dataUrl = 'offers/requestedOffers';
    
    return this._dataTableService.handleResolverRequest(
      dataUrl,
      (params) => {
        if (this._listState.listFilter) {
          params.$filter = this._listState.listFilter;
        }
        return this._http.post(`api/offers/requestedOffers`, req, { params });
      },
      route.queryParams,
      LOCAL_STORAGE_KEY.PAGE_SIZE_OFFERS_LIST
    );
  }
}

// @Injectable()
// export class OffersListCachedFilterDataResolve implements Resolve<any> {
//   constructor(private _http: HttpClient) { }
//   resolve(route: ActivatedRouteSnapshot): Observable<IOffersListFilterDataDto> {
//     return this._http.get(`api/offers/cachedfilterData/${route.paramMap.get("searchKey")}`) as Observable<any>;
//   }
// }